import { render } from "./booking-content.vue?vue&type=template&id=9b3168e6"
import script from "./booking-content.vue?vue&type=script&lang=js"
export * from "./booking-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__